export function parseArrayIntoString<Type>(
  array: Array<Type>,
  key: keyof Type,
  separator: string,
): string {
  const valueArray = array.map((item) => String(item[key]));
  return valueArray.join(separator);
}
